var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.898 13.777C11 13.395 11 12.93 11 12c0-.93 0-1.395-.102-1.777a3 3 0 00-2.122-2.12C8.395 8 7.93 8 7 8s-1.395 0-1.776.102a3 3 0 00-2.122 2.121C3 10.605 3 11.07 3 12c0 .93 0 1.395.102 1.777a3 3 0 002.122 2.12C5.605 16 6.07 16 7 16s1.395 0 1.776-.102a3 3 0 002.122-2.121zM11 12h10",
    stroke: "#2F3C33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 1,
    fill: "#2F3C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15v-3M19 15v-3",
    stroke: "#2F3C33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgKey;